import React, { useState } from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField,
    Button, Typography, IconButton, Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {useTheme} from "@mui/material/styles";

function DeleteConfirmationDialog(props) {
    const [open, setOpen] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const theme = useTheme();
    const showDialog = () => {
        setOpen(true);
    };

    const hideDialog = () => {
        setOpen(false);
        setInputValue(""); 
    };

    const confirmRequest = () => {
        props.response();
        hideDialog();
    };

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    return (
        <>
            {props.children(showDialog)}
            {open && (
                <Dialog
                    open={open}
                    onClose={hideDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth="xs"
                    fullWidth
                >
                    <Box
                        sx={{
                            backgroundColor: (theme) => theme.palette.primary.main,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            px: 2,
                            py: 1,
                        }}
                    >
                        <Typography
                            variant='h6'
                            sx={{ color: (theme) => theme.palette.primary.contrastText }}
                        >
                            {props.header ?? "Delete Confirmation" }
                        </Typography>
                        <IconButton
                            aria-label='close'
                            onClick={hideDialog}
                            sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {props.description}
                        </DialogContentText>
                        <TextField
                            sx={{
                                mt: 4,
                                mb: 2,
                                maxWidth: 250,
                            }}
                            autoFocus
                            margin="dense"
                            label="Type 'delete' to confirm"
                            fullWidth
                            variant="outlined"
                            value={inputValue}
                            onChange={handleInputChange}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={confirmRequest}
                            color="primary"
                            variant="contained"
                            disabled={inputValue.toLowerCase() !== "delete"}
                        >
                            Confirm
                        </Button>
                        <Button onClick={hideDialog} color="primary" variant="outlined">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
}

export default DeleteConfirmationDialog;